// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1776": "aa2f9ae04fc6","2305": "99a4f8f20085","4337": "352e5e954f45","7178": "757b2dc99adc","8795": "771c29ae18b2","9932": "82ab7560b35d",}[chunkId] + ".css"
}